export const validateEmail = (text) => {
  let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(String(text).toLowerCase());
};

export const validateDisplayName = (text) => {
  let regex = /^(\d|\w)+$/;
  return regex.test(String(text).toLowerCase());
};

export const invalidEmailAndDisplayName = ({ email, displayName }) => {
  return !(validateDisplayName(displayName) && validateEmail(email));
};
